import { render, staticRenderFns } from "./CaregiverBoard.vue?vue&type=template&id=8ee13a22&scoped=true"
import script from "./CaregiverBoard.vue?vue&type=script&lang=js"
export * from "./CaregiverBoard.vue?vue&type=script&lang=js"
import style0 from "./CaregiverBoard.vue?vue&type=style&index=0&id=8ee13a22&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8ee13a22",
  null
  
)

export default component.exports